import { Link } from "react-router-dom";

export default function ProfileMenu({
  authUser,
  isAdmin,
  menuOpen,
  onToggle,
  onSignOut,
  overDark,
  menuRef,
}) {
  const initials = authUser
    ? (authUser.displayName || authUser.email || "?").slice(0, 2).toUpperCase()
    : "";
  const firstName = authUser?.displayName?.split(" ")[0] || authUser?.email?.split("@")[0] || "Account";
  const photoURL = authUser?.photoURL;

  return (
    <div ref={menuRef} style={{ position: "relative" }}>
      <button
        className="nav-profile-btn"
        onClick={onToggle}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "3px 12px 3px 8px",
          background: overDark
            ? (menuOpen
              ? "linear-gradient(180deg, rgba(255,255,255,.08), rgba(255,255,255,.03))"
              : "linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.02))")
            : (menuOpen ? "var(--bg-surface)" : "var(--bg-ghost)"),
          border: overDark ? "1px solid rgba(255,255,255,.1)" : "1px solid var(--border-subtle)",
          borderRadius: 999,
          cursor: "pointer",
          transition: "background .15s",
          outline: "none",
        }}
      >
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            flexShrink: 0,
            overflow: "hidden",
            background: overDark ? "linear-gradient(135deg, rgba(129,140,248,.8), rgba(167,139,250,.8))" : "linear-gradient(135deg,#818cf8,#a78bfa)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 10,
            fontWeight: 700,
            color: overDark ? "rgba(245,245,247,.94)" : "#fff",
            letterSpacing: ".03em",
          }}
        >
          {photoURL ? <img src={photoURL} alt="avatar" style={{ width: 20, height: 20, objectFit: "cover" }} /> : initials}
        </div>
        <span style={{ fontSize: 13, fontWeight: 500, color: "inherit" }}>{firstName}</span>
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ transform: menuOpen ? "rotate(180deg)" : "none", transition: "transform .15s", opacity: 0.55 }}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>

      <div className={`nav-profile-dropdown${menuOpen ? " open" : ""}${overDark ? " bg-dark" : " bg-light"}`}>
        <div className="nav-dropdown-divider" style={{ padding: "10px 12px 10px", borderBottom: "1px solid transparent", marginBottom: 6 }}>
          <div className="nav-dropdown-name" style={{ fontSize: 13, fontWeight: 600, marginBottom: 2 }}>
            {authUser.displayName || "User"}
          </div>
          <div className="nav-dropdown-email" style={{ fontSize: 11, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150 }}>
            {authUser.email}
          </div>
        </div>

        <Link to="/dashboard" className="nav-menu-item">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
          </svg>
          Dashboard
        </Link>

        <Link to="/profile" className="nav-menu-item">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          Profile
        </Link>

        {isAdmin && (
          <a href="https://admin.ateno.co" className="nav-menu-item" target="_blank" rel="noopener noreferrer">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            Admin
          </a>
        )}

        <div className="nav-dropdown-divider" style={{ borderTop: "1px solid transparent", margin: "6px 0" }} />
        <button
          onClick={onSignOut}
          className="nav-menu-item nav-menu-item-danger"
          style={{ width: "100%", background: "none", border: "none", cursor: "pointer", textAlign: "left" }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Sign out
        </button>
      </div>
    </div>
  );
}
